import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { UserIcon, ClockIcon, CrosshairIcon, ZapIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
const benefits = [{
  icon: UserIcon,
  text: 'The procedure is suitable for various body areas, including the face, legs, arms, underarms, and bikini line.'
}, {
  icon: ClockIcon,
  text: 'Laser hair removal provides a reduction in hair growth over time, leading to long-lasting results compared to traditional methods like shaving or waxing.'
}, {
  icon: CrosshairIcon,
  text: 'The Candela GentleMax Pro system allows for precise targeting of specific areas, ensuring effective hair removal without affecting surrounding skin.'
}, {
  icon: ZapIcon,
  text: 'The procedure is relatively quick, especially for smaller treatment areas, making it a convenient option for individuals with busy schedules.'
}, {
  icon: ShieldCheckIcon,
  text: 'Unlike traditional hair removal methods, laser hair reduction helps minimize the occurrence of ingrown hairs.'
}, {
  icon: SparklesIcon,
  text: 'With consistent sessions, laser hair removal contributes to smoother skin texture, eliminating the need for regular plucking, shaving or waxing.'
}];
export function LHBenefits() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1550">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1551">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1552">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1553">
            BENEFITS OF HAIR REDUCTION TREATMENTS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1554"></div>
          <p className="text-[#B0B0B0] text-[17px] leading-[1.7] font-body max-w-[800px]" data-id="element-1555">
            At Be CLINICAL we want our patients to achieve the best possible
            results, which is why we use the Candela GentleMax Pro. It is the
            most advanced laser technology on the market that can safely treat
            skin types I-VI. Using the Candela Pro Max system offers numerous
            benefits, including:
          </p>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1556">
          {benefits.map((benefit, index) => <AnimateOnScroll key={index} delay={index * 80} data-id="element-1557">
              <div className="bg-[#111111] p-8 text-center h-full group hover:shadow-[0_0_20px_rgba(255,20,147,0.1)] transition-shadow duration-300" data-id="element-1558">
                <benefit.icon size={40} strokeWidth={1.5} className="text-[#FF1493] mx-auto mb-5 group-hover:scale-110 transition-transform duration-300" data-id="element-1559" />
                <p className="text-white text-[15px] leading-[1.6] font-body" data-id="element-1560">
                  {benefit.text}
                </p>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}